export default{
    getSearchString(key){
        var str = location.href.substring(location.href.indexOf('?'));
        str = str.substring(1, str.length);


        var arr = str.split("&");
        var obj = new Object();

        for (var i = 0; i < arr.length; i++) {
            var tmp_arr = arr[i].split("=");
            obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
        }
        return obj[key];
    },
}